import { createVanIconComponent } from "./van"

const BagOutlined = createVanIconComponent("bag-o")
export default BagOutlined
